module.exports = __webpack_public_path__ + "assets/icon-installation-selected.ac7712a4.svg";